import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Box,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useMainContext } from "../../../../../../context/useMainContext";
import { useState } from "react";
import { supabase } from "../../../../../../supabase";
import toast from "react-hot-toast";

export default ({ open, setOpen, justAddedProfile }) => {
  const { availableUsers, setRows } = useMainContext();
  const [value, setValue] = useState("");
  const handleClose = () => {
    setValue("");
    setOpen(false);
  };

  const handleContactPersonModalSubmit = async ({ selectedContactPerson }) => {
    const { error } = await supabase
      .from("influencers")
      .update({ assigned_member: selectedContactPerson.name })
      .eq("id", justAddedProfile?.id);

    if (error) {
      toast.error("Failed to update assigned member.");
      return;
    }
    setRows((prevRows) =>
      prevRows.map((r) => (r.id === justAddedProfile?.id ? { ...r, assigned_member: selectedContactPerson?.name } : r))
    );
    toast.success("Assigned member updated!");
    setValue("");
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Assign Contact Person
        <IconButton onClick={handleClose} size="small" aria-label="Close dialog">
          <CloseOutlinedIcon />
        </IconButton>
      </DialogTitle>

      <Box sx={{ px: 3 }}>
        <FormControl variant="outlined" fullWidth size="small">
          <InputLabel id="assign-contact-person-label">Assign contact person</InputLabel>
          <Select
            value={value}
            label={"Assign contact person"}
            labelId="assign-contact-person-label"
            onChange={async (e) => {
              setValue(e.target.value);
            }}
          >
            {availableUsers.map((user) => (
              <MenuItem key={user.id} value={user}>
                {user.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <DialogActions sx={{ p: 3 }}>
        <Button variant="outlined" onClick={handleClose} disableElevation size="large" fullWidth sx={{ mr: 1 }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => handleContactPersonModalSubmit({ selectedContactPerson: value })}
          disableElevation
          size="large"
          disabled={!value}
          fullWidth
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};
